import { render, staticRenderFns } from "./Pedido.vue?vue&type=template&id=b3b97a28&scoped=true"
import script from "./Pedido.vue?vue&type=script&lang=js"
export * from "./Pedido.vue?vue&type=script&lang=js"
import style0 from "./Pedido.vue?vue&type=style&index=0&id=b3b97a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b97a28",
  null
  
)

export default component.exports